// extracted by mini-css-extract-plugin
module.exports = {"newsRow":"Header_newsRow__3ymZj","Header":"Header_Header__1MtPM","Logo":"Header_Logo__2nNRG"};